import React, { Component } from 'react';
import { connect } from 'react-redux';

import './css/bootstrap.min.css';
import './css/fontawesome-all.min.css';
import './css/login.css';
import './css/login2.css';
import PropTypes from 'prop-types';
import {} from 'antd';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import handsOnLogo from './images/handson_w_lg.png';
import leftGraphicMuseumSense from './images/LeftGraphicMuseumSense.png';
// import museumSenseLogo from './images/logo.png';
import museumSenseLogo2 from '../../assets/images/logo.png';
import { login } from '../../actions/AuthActions';

class LoginPage extends Component {
  handleSubmit = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        const { props } = this;
        props.login(values.username, values.password);
      }
    });
  };

  render() {
    const { form } = this.props;
    const { getFieldDecorator } = form;
    return (
      <div className="form-body login-form" id="login-page">
        <div className="website-logo">
          <a>
            <div className="logo">
              <img className="logo-size" src={museumSenseLogo2} alt="" />
            </div>
          </a>
        </div>
        <div className="row">
          <div className="img-holder">
            <div className="bg"></div>
            <div className="info-holder">
              <img src={leftGraphicMuseumSense} alt="" />
            </div>
          </div>
          <div className="form-holder">
            <div className="form-content">
              <div className="form-items" id="loginPage">
                <h3>Manage your collection with ease today.</h3>
                <p>
                  Welcome to the freshest and most powerful Museum Collection
                  Management System available in the market.
                </p>
                <div className="page-links">
                  <a className="active">Login</a>
                </div>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Item style={{ marginBottom: 0, paddingBottom: 0 }}>
                    {getFieldDecorator('username', {
                      rules: [],
                    })(
                      <input
                        className="form-control"
                        id="form-username"
                        type="text"
                        name="username"
                        placeholder="Username"
                        required=""
                        autoComplete="off"
                        style={{
                          backgroundImage: `url(
                        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAkCAYAAADo6zjiAAAAAXNSR0IArs4c6QAAAbNJREFUWAntV8FqwkAQnaymUkpChB7tKSfxWCie/Yb+gbdeCqGf0YsQ+hU95QNyDoWCF/HkqdeiIaEUqyZ1ArvodrOHxanQOiCzO28y781skKwFW3scPV1/febP69XqarNeNTB2KGs07U3Ttt/Ozp3bh/u7V7muheQf6ftLUWyYDB5yz1ijuPAub2QRDDunJsdGkAO55KYYjl0OUu1VXOzQZ64Tr+IiPXedGI79bQHdbheCIAD0dUY6gV6vB67rAvo6IxVgWVbFy71KBKkAFaEc2xPQarXA931ot9tyHphiPwpJgSbfe54Hw+EQHMfZ/msVEEURjMfjCjbFeG2dFxPo9/sVOSYzxmAwGIjnTDFRQLMQAjQ5pJAQkCQJ5HlekeERxHEsiE0xUUCzEO9AmqYQhiF0Oh2Yz+ewWCzEY6aYKKBZCAGYs1wuYTabKdNNMWWxnaA4gp3Yry5JBZRlWTXDvaozUgGTyQSyLAP0dbb3DtQlmcan0yngT2ekE9ARc+z4AvC7nauh9iouhpcGamJeX8XF8MaClwaeROWRA7nk+tUnyzGvZrKg0/40gdME/t8EvgG0/NOS6v9NHQAAAABJRU5ErkJggg==')`,
                          backgroundRepeat: 'no-repeat',
                          backgroundAttachment: 'scroll',
                          backgroundSize: '16px 18px',
                          backgroundPosition: '98% 50%',
                        }}
                      />,
                    )}
                  </Form.Item>
                  <Form.Item style={{ marginBottom: 0, paddingBottom: 0 }}>
                    {getFieldDecorator('password', {
                      rules: [],
                    })(
                      <input
                        className="form-control"
                        id="form-password"
                        type="password"
                        name="password"
                        placeholder="Password"
                        required=""
                        autoComplete="off"
                        style={{
                          backgroundImage: `url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAkCAYAAADo6zjiAAAAAXNSR0IArs4c6QAAAbNJREFUWAntV8FqwkAQnaymUkpChB7tKSfxWCie/Yb+gbdeCqGf0YsQ+hU95QNyDoWCF/HkqdeiIaEUqyZ1ArvodrOHxanQOiCzO28y781skKwFW3scPV1/febP69XqarNeNTB2KGs07U3Ttt/Ozp3bh/u7V7muheQf6ftLUWyYDB5yz1ijuPAub2QRDDunJsdGkAO55KYYjl0OUu1VXOzQZ64Tr+IiPXedGI79bQHdbheCIAD0dUY6gV6vB67rAvo6IxVgWVbFy71KBKkAFaEc2xPQarXA931ot9tyHphiPwpJgSbfe54Hw+EQHMfZ/msVEEURjMfjCjbFeG2dFxPo9/sVOSYzxmAwGIjnTDFRQLMQAjQ5pJAQkCQJ5HlekeERxHEsiE0xUUCzEO9AmqYQhiF0Oh2Yz+ewWCzEY6aYKKBZCAGYs1wuYTabKdNNMWWxnaA4gp3Yry5JBZRlWTXDvaozUgGTyQSyLAP0dbb3DtQlmcan0yngT2ekE9ARc+z4AvC7nauh9iouhpcGamJeX8XF8MaClwaeROWRA7nk+tUnyzGvZrKg0/40gdME/t8EvgG0/NOS6v9NHQAAAABJRU5ErkJggg==")`,
                          backgroundRepeat: 'no-repeat',
                          backgroundAttachment: 'scroll',
                          backgroundSize: '16px 18px',
                          backgroundPosition: '98% 50%',
                        }}
                      />,
                    )}
                  </Form.Item>
                  <div className="form-button">
                    <button
                      type="button"
                      id="loginBtn"
                      className="ibtn"
                      onClick={this.handleSubmit}
                    >
                      Login
                    </button>
                  </div>

                  <div className="errors">
                    <div
                      className="alert alert-danger"
                      role="alert"
                      id="credentialsError"
                      style={{ display: 'none' }}
                    >
                      Incorrect username or password.
                    </div>
                    <div
                      className="alert alert-danger"
                      role="alert"
                      id="cannotLogInError"
                      style={{ display: 'none' }}
                    >
                      Could not log you in.
                    </div>
                    <div
                      className="alert alert-danger"
                      role="alert"
                      id="permissionsError"
                      style={{ display: 'none' }}
                    >
                      You do not have permission to do this action.
                    </div>
                  </div>
                  <input type="submit" style={{ display: 'none' }} />
                </Form>

                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a href="http://www.handsonsystems.com" target="_blank">
                  <div className="handson-logo">
                    <img src={handsOnLogo} alt="" />
                  </div>
                </a>

                <div className="other-links">
                  <span>
                    {' '}
                    &copy; {new Date().getFullYear()} All rights reserved.
                    Produced by HandsOn Systems.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

LoginPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object,
  login: PropTypes.func,
};

const LoginPageWithForm2 = Form.create({ name: 'login_page' })(LoginPage);

function mapStateToProps({ auth }) {
  const { loggingIn } = auth;
  return { loggingIn };
}

export default connect(mapStateToProps, { login })(LoginPageWithForm2);
